import { render, staticRenderFns } from "./user-settings.vue?vue&type=template&id=c93dc450&scoped=true&"
import script from "./user-settings.vue?vue&type=script&lang=js&"
export * from "./user-settings.vue?vue&type=script&lang=js&"
import style0 from "./user-settings.vue?vue&type=style&index=0&id=c93dc450&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93dc450",
  null
  
)

export default component.exports